<div class="rounded-xl border border-warn-200 overflow-hidden" role="alert" data-testid="claim-lock-notice">
  <div class="flex gap-3 items-center bg-warn-50 px-4 py-3">
    <vs-icon name="alert-circle" class="text-warn-500 shrink-0"></vs-icon>
    <p class="text-sm font-semibold text-warn-800 min-w-0">{{ current.title }}</p>
  </div>

  <div class="divide-y divide-gray-100">
    <vs-accordion *ngFor="let section of sections" [open]="section.open" [attr.data-testid]="'lock-' + section.key">
      <button
        slot="header"
        type="button"
        class="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 focus-visible:outline-none focus-visible:bg-gray-50"
        [attr.aria-expanded]="section.open"
        (click)="section.open = !section.open"
      >
        <vs-icon [name]="$any(section.icon)" class="text-gray-500 shrink-0"></vs-icon>
        <span class="flex-1 text-sm font-medium text-gray-900">{{ section.label }}</span>
        <vs-badge [theme]="section.theme">{{ section.badge }}</vs-badge>
        <vs-icon
          name="chevron-down"
          class="text-gray-400 shrink-0 transition-transform"
          [class.rotate-180]="section.open"
        ></vs-icon>
      </button>

      <ul slot="content" class="flex flex-col gap-1.5 px-4 pb-3 pl-11 text-sm text-gray-700">
        <li *ngFor="let item of section.items" class="flex gap-2">
          <span class="text-gray-400" aria-hidden="true">•</span>
          <span>{{ item }}</span>
        </li>
      </ul>
    </vs-accordion>
  </div>
</div>
